import { ScanSearch, BookOpen, User, Star } from "lucide-react";

const items = [
  { key: "scanner", label: "Scanner", Icon: ScanSearch },
  { key: "diario", label: "Diario", Icon: BookOpen },
  { key: "preferiti", label: "Preferiti", Icon: Star },
  { key: "progressi", label: "Profilo", Icon: User },
];

export const BottomNav = ({ current, onChange }) => {
  return (
    <div
      className="fixed mb-nav-el left-1/2 -translate-x-1/2 w-[calc(100%-2rem)] max-w-[408px] z-50 rounded-2xl bg-white/85 backdrop-blur-xl border border-white/60 shadow-[0_8px_32px_rgba(43,144,239,0.18)] p-2 flex justify-between items-center"
      style={{ bottom: "calc(1.25rem + env(safe-area-inset-bottom))" }}
      data-testid="bottom-nav"
    >
      {items.map(({ key, label, Icon }) => {
        const active = current === key;
        return (
          <button
            key={key}
            data-testid={`nav-${key}`}
            onClick={() => onChange(key)}
            className={`flex-1 flex flex-col items-center gap-1 py-3 rounded-xl transition-colors duration-200 active:scale-95 ${
              active ? "bg-[#e0f2fe] text-[#2b90ef]" : "text-slate-400 hover:text-slate-600"
            }`}
          >
            <Icon size={24} strokeWidth={active ? 2.6 : 2} />
            <span className="text-[11px] font-semibold font-display">{label}</span>
          </button>
        );
      })}
    </div>
  );
};
